var department_gallery_options = {
	arrows: false, 
	dots: true, 
	infinite: false
};

$(function(){
	$('.department_gallery').slick(department_gallery_options)
	.on('breakpoint', function(event, slick, breakpoint){
		slick.setPosition();
	});

	$('.departments_list_slider').slick({
		arrows: false, 
		infinite: false, 
		fade: true, 
		draggable: false, 
		swipe: false, 
		touchMove: false
	});

	$('.rooms_names_list').slick({
		arrows: false, 
		infinite: false, 
		variableWidth: true, 
		swipeToSlide: true, 
		mobileFirst: true, 
		responsive: [
		    {
		      	breakpoint: 768,
		      	settings: "unslick"
		    }
	    ]
	}).on('breakpoint', function(event, slick, breakpoint){
		slick.setPosition();
	});

	$('.departments_slider_menu').slick({
		arrows: false, 
		infinite: false, 
		variableWidth: true, 
		swipeToSlide: true, 
		mobileFirst: true, 
		responsive: [
		    {
		      	breakpoint: 992,
		      	settings: "unslick"
		    }
	    ]
	});
});

$(document).on('click', '.departments_slider_menu .item', function(){
	if(this.classList.contains('active')) return;
	var this_elem = this;

	var section = $(this).parents('.departments_section');
	if(section.loading) return;

	var item_id = this.dataset.id;
	var slider = section.find('.departments_list_slider').eq(0);
	var index = Array.prototype.indexOf.call(this.parentElement.children, this);

	$(this).addClass('active').siblings().removeClass('active');
	
	if(!this.dataset.loaded){
		section.loading = 1;
		incube_ajax('department', 'html', 'get_department_block', {
			'id': item_id, 
			'dep_id': section.data('dep'), 
			'stuff_id': section.data('stuff')
		}, function(response){
			var new_slide = $('<div class="item" data-id="'+item_id+'">'+response+'</div>');
			slider.slick('slickAdd', new_slide);
			section.loading = 0;
			this_elem.dataset.loaded = 1;
			slider.slick('slickNext');

			new_slide.find('.department_gallery').slick(department_gallery_options);
		});
	}else{
		var next_slide = slider.find('.item[data-id="'+item_id+'"]');
		var next_slide_index = next_slide.index();
		slider.slick('slickGoTo', next_slide_index);

		//next_slide.find('.department_gallery').slick(department_gallery_options);
	}
});


$(document).on('click', '.rooms_names_list .item', function(){
	if($(this).hasClass('active')) return;

	var room_id = $(this).data('id');

	var section = $(this).parents('.rooms_list_section');

	if(section[0].loading) return;

	section.find('.room_info_item').removeClass('active');

	var target_room_info = section.find('.room_info_item[data-id="'+room_id+'"]');
	if(target_room_info.length){
		target_room_info.addClass('active');
	}else{
		section[0].loading = 1;
		incube_ajax('department', 'html', 'get_room_info', {'id': room_id}, function(response){
			var new_item = $('<div class="room_info_item active" data-id="'+room_id+'">'+response+'</div>');
			section.find('.rooms_info_list').append(new_item);
			section[0].loading = 0;
		});
	}

	$(this).addClass('active')
	.siblings().removeClass('active');
});